import { pathOr } from "ramda";
import { GRAPH_URL } from "../../../constants";
import { getAuthorizationHeader } from "./authorization";

const query = `
    mutation LoginWithFacebookMutation($accessToken: String!, $userFacebookId: String!, $deviceInfo: JSON) {
        loginWithFacebook(accessToken: $accessToken, deviceInfo: $deviceInfo, userFacebookId: $userFacebookId) {
            id
            token
            facebookPages
        }
    }
`;

const loginWithFacebook = variables =>
  fetch(GRAPH_URL, {
    method: "POST",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
      // ...getAuthorizationHeader(),
    },
    body: JSON.stringify({ query, variables }),
  })
    .then(res => res.json())
    .then(res => {
      const login = pathOr(null, ["data", "loginWithFacebook"])(res);
      if (login) {
        return { ...login };
      }
    })
    .catch(error => console.log("Error loginWithFacebook", { error }));

export default loginWithFacebook;
